<template>
  <Select
    v-if="isVisible()"
    v-model="value"
    :options="props.params.options"
    :optionLabel="props.params.optionsLabel"
    :placeholder="props.params.placeholder"
    class="w-full h-8 align-middle"
    labelClass="self-center"
    scrollHeight="50rem"
    @change="onChange()"
  >
  </Select>
</template>

<script setup lang="ts">
const props = defineProps(["params"]);

const value = ref(props.params.value);

const isVisible = (): boolean => {
  if (props.params.checkVisible != null) return props.params.checkVisible(props.params.data);
  return true;
};

const onChange = (): void => {
  if (props.params.setValue != null) props.params.setValue(props.params.node.rowIndex, value.value);
};
</script>
